export enum TaskManagerTaskState {
  Pending = 1,
  Approved,
  UpdateRequested,
  Declined,
}
